import React, { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { history } from "../../../../routers/AppRouter";
import moment from 'moment';
import styled from 'styled-components'
import { useTable, useRowSelect } from 'react-table';
import { connect } from "react-redux";

import { getClients } from '../../../../actions/clients';
import MainButton from '../../../../components/MainButton';
import { getOnlineStats, updateOnlineStatPriority } from '../../../../actions/portal/online-stats';
import { ToastContainer, toast } from 'react-toastify/index';

const Styles = styled.div`
  padding: 1rem;

  .table-wrapper {
    width: 100%;
    overflow-x: auto;   /* enables horizontal scroll */
  }

  table {
    border-spacing: 0;
    border: 1px solid black;
    min-width: 1200px;  /* or whatever width fits your columns */
  }

  th,
  td {
    margin: 0;
    padding: 0.5rem;
    border-bottom: 1px solid black;
    border-right: 1px solid black;
    white-space: nowrap; /* prevents squishing */
  }

  th:last-child,
  td:last-child {
    border-right: 0;
  }
`;

const HeadingContainer = styled.div`
  display: flex;
  align-items: center;
`;

const StyledHeading = styled.div`
  padding: 10px 10px 10px 0;
  font-size: 40px;
`;

const Title = styled.div`
  cursor: pointer;
`;

const ImageStyle = styled.div`
  cursor: pointer;
  img {
    width: 65px;
  }
`;

const LinkStyle = styled.div`
  cursor: pointer;
  max-width: 200px;   /* required */
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ButtonStyle = styled.button`
  cursor: pointer;
`;

const ButtonPadding = styled.div`
  padding: 0 5px;
`;

const IndeterminateCheckbox = React.forwardRef(
    ({ indeterminate, ...rest }, ref) => {
        const defaultRef = React.useRef();
        const resolvedRef = ref || defaultRef;

        React.useEffect(() => {
            resolvedRef.current.indeterminate = indeterminate
        }, [resolvedRef, indeterminate]);

        return (
            <>
                <input type="checkbox" ref={resolvedRef} {...rest} />
            </>
        )
    }
);

const handleEditRow = (d) => {
    history.push({
        pathname: `client/${d.id}`,
        state: {
            data: d,
        },
    });
};

function Table({ columns, data, updateOnlineStatPriority }) {
    // Use the state and functions returned from useTable to build your UI
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        selectedFlatRows,
        state: { selectedRowIds },
    } = useTable(
        {
            columns,
            data,
        },
        useRowSelect,
        hooks => {
            hooks.allColumns.push(columns => [
                // Let's make a column for selection
                {
                    id: 'selection',
                    // The header can use the table's getToggleAllRowsSelectedProps method
                    // to render a checkbox
                    Header: ({ getToggleAllRowsSelectedProps }) => (
                        <div>
                            <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
                        </div>
                    ),
                    // The cell can use the individual row's getToggleRowSelectedProps method
                    // to the render a checkbox
                    Cell: ({ row }) => (
                        <div>
                            <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
                        </div>
                    ),
                },
                ...columns,
            ])
        }
    );

    const makePriority = () => {
        const ids = selectedFlatRows.map(row => row.original.id);
        if (!ids.length) return;
        updateOnlineStatPriority(ids, true);
    };

    const removePriority = () => {
        const ids = selectedFlatRows.map(row => row.original.id);
        if (!ids.length) return;
        updateOnlineStatPriority(ids, false);
    };

    // Render the UI for your table
    return (
        <>
            <HeadingContainer>
                <StyledHeading>Online Stats</StyledHeading>
                <MainButton
                    title="Make Multiple Priority"
                    onClick={makePriority}
                />
                <ButtonPadding>
                    <MainButton
                        title="Remove Multiple Priority"
                        onClick={removePriority}
                    />
                </ButtonPadding>
            </HeadingContainer>
            <div className="table-wrapper">
                <table {...getTableProps()}>
                    <thead>
                        {headerGroups.map(headerGroup => (
                            <tr {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map(column => (
                                    <th {...column.getHeaderProps()}>{column.render('Header')}</th>
                                ))}
                            </tr>
                        ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                        {rows.slice(0, 500).map((row, i) => {
                            prepareRow(row);
                            return (
                                <tr {...row.getRowProps()}>
                                    {row.cells.map(cell => {
                                        return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                                    })}
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
            <p>Selected Rows: {Object.keys(selectedRowIds).length}</p>
            <pre>
                <code>
                    {JSON.stringify(
                        {
                            selectedRowIds: selectedRowIds,
                            'selectedFlatRows[].original': selectedFlatRows.map(
                                d => d.original
                            ),
                        },
                        null,
                        2
                    )}
                </code>
            </pre>
            <ToastContainer />
        </>
    )
}

function OnlineStats(props) {

    useEffect(() => {
        props.getOnlineStats()
    }, []);

    useEffect(() => {
        if (props.prioritySuccess) {
            toast.success("Priority Update Success");
        }
    }, [props.prioritySuccess]);

    const columns = React.useMemo(
        () => [
            {
                Header: 'Online Stat Lead Info',
                columns: [
                    // {
                    //   Header: 'Item ID',
                    //   accessor: data => {
                    //     return <Title onClick={() => handleEditRow(data)}>{data.id}</Title>;
                    //   },
                    // },
                    {
                        Header: 'Client ID',
                        accessor: data => {
                            return <Title onClick={() => handleEditRow(data)}>{data.id}</Title>
                        },
                    },
                    {
                        Header: 'Priority',
                        accessor: d => {
                            if (d.priority === false) {
                                return '0';
                            } else if (d.priority === true) {
                                return '1';
                            } else {
                                return 'not set'
                            }
                        },
                    },
                    {
                        Header: 'Date',
                        accessor: d => {
                            return moment(d.date).format('MMM. Do, YYYY');
                        }
                    },
                    {
                        Header: 'Company',
                        accessor: d => {
                            return <Title>{d.profile?.company ?? ''}</Title>
                        },
                    },
                    {
                        Header: 'Ad',
                        accessor: d => {
                            return <ImageStyle><img src={`https://${d.imageUrl}`} /></ImageStyle>
                        },
                    },
                    {
                        Header: 'Link',
                        accessor: d => {
                            return <LinkStyle><a href={d.externalLink} target='_blank'>{d.externalLink}</a></LinkStyle>
                        },
                    },
                    {
                        Header: 'Content Type',
                        accessor: d => {
                            return <Title>{d.contentType}</Title>
                        },
                    },
                    {
                        Header: 'First Name',
                        accessor: d => {
                            return <Title>{d.profile?.firstName ?? ''}</Title>
                        },
                    },
                    {
                        Header: 'Last Name',
                        accessor: d => {
                            return <Title>{d.profile?.lastName ?? ''}</Title>
                        },
                    },
                    {
                        Header: 'Email',
                        accessor: d => {
                            return <Title>{d.user?.email ?? ''}</Title>
                        },
                    },
                    {
                        Header: 'Job Title',
                        accessor: d => {
                            return <LinkStyle>{d.profile?.jobTitle ?? ''}</LinkStyle>
                        },
                    },

                    // {
                    //     Header: 'Edit',
                    //     accessor: data => {
                    //         return <ButtonStyle onClick={() => handleEditRow(data)}>Edit</ButtonStyle>;
                    //     },
                    // },
                ],
            },
        ],
        []
    );

    return (
        <Styles>
            <Table columns={columns} data={props.onlineStats} updateOnlineStatPriority={props.updateOnlineStatPriority} />
        </Styles>
    )
}

const mapStateToProps = (state) => {
    return {
        onlineStats: state.onlineStats.data,
        prioritySuccess: state.onlineStats.prioritySuccess
    };
};

const mapDispatchToProps = (dispatch) => ({
    getOnlineStats: () => dispatch(getOnlineStats()),
    updateOnlineStatPriority: (onlineStats, priority) => dispatch(updateOnlineStatPriority(onlineStats, priority)),
});

export default connect(mapStateToProps, mapDispatchToProps)(OnlineStats);
